/* ArteTrofeo · creador de trofeo v3: campos, encuadre del cliente, colores, regla de ciudad, vista previa y bloqueo del carrito. Gesta: horizontal o cuadrado. */
(() => {
 const SPEC = {
  hito: { d: [90, 90, 90, 90], m: 0 },
  marca: { d: [195, 125, 165, 95], m: 15 },
  gesta: { d: [230, 150, 190, 110], m: 20 },
  gestaC: { d: [240, 240, 200, 200], m: 20 },
  leyenda: { d: [300, 210, 250, 160], m: 25 },
 };
 const EDIF = 'Ciudad con edificios';
 const MAX_KM = 21.6;
 const coma = (n, d) => n.toFixed(d).replace('.', ',');

 const init = (cfgEl) => {
  if (cfgEl.dataset.ready) return;
  cfgEl.dataset.ready = '1';
  const C = JSON.parse(cfgEl.textContent);
  const T = C.t;
  let sp, W, H, MW, MH, A, cuad = false;
  const sd = C.en ? '.' : ',';
  const miles = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, C.en ? ',' : '.');
  const kmTxt = (km) =>
   Math.abs(km - 42.195) < 0.6 ? `42${sd}195 KM` : Math.abs(km - 21.0975) < 0.4 ? `21${sd}097 KM` : km.toFixed(km >= 100 ? 0 : 1).replace('.', sd) + ' KM';
  const $r = () => document.querySelector(`[data-atc="${C.uid}"]`);
  const q = (s) => $r()?.querySelector(s);
  const qa = (s) => [...($r()?.querySelectorAll(s) || [])];
  const val = (k) => (q(`[data-atc-in="${k}"]`)?.value || '').trim();
  const S = { pts: null, st: null, gpxErr: false, v: null, v0: null, s: 0, manual: false, visto: false };

  /* Medidas de la pieza según modelo y formato (la Gesta puede ir en cuadrado 24×24 con mapa de 20×20) */
  const fijar = () => {
   cuad = C.modelo === 'gesta' && q('[data-atc-formato]:checked')?.value === 'Cuadrado';
   sp = SPEC[cuad ? 'gestaC' : C.modelo] || SPEC.gesta;
   [W, H, MW, MH] = sp.d;
   A = MW / MH;
  };
  fijar();

  const color = () => q('[data-atc-color]:checked')?.dataset.atcColor || '#2F6BFF';
  const mapa = () => (q('[data-atc-mapa-color]:checked')?.value === 'Negro' ? 'negro' : 'blanco');
  const tipo = () => q('[data-atc-tipo]:checked')?.value || '';
  const despues = () => !!q('[data-atc-despues]')?.checked;
  const perfil = () => /perfil|profil/i.test(q('[data-atc-borde]:checked')?.value || '');

  const ciudad = () => {
   if (tipo() !== EDIF) return '';
   if (C.modelo !== 'leyenda') return 'bloqueo';
   if (S.st) return S.st.km > MAX_KM ? 'largo' : 'ok';
   return q('[data-atc-conf] input')?.checked ? 'ok' : 'confirmar';
  };

  const motivo = () => {
   if (!$r()) return '';
   if (!val('carrera')) return 'carrera';
   if (!(S.pts && !S.gpxErr) && !val('enlace')) return 'recorrido';
   if (!tipo()) return 'tipo';
   const c = ciudad();
   if (c === 'bloqueo' || c === 'largo') return 'ciudad';
   if (c === 'confirmar') return 'confirmar';
   if (!despues() && !val('nombre')) return 'nombre';
   return '';
  };

  const datos = () => {
   const dp = despues();
   const km = S.st ? Math.round(S.st.km * 10) / 10 : 0;
   const dm = S.st && S.st.dmas != null ? Math.round(S.st.dmas / 10) * 10 : null;
   return { carrera: val('carrera'), km, dm, g: dm == null || dm / Math.max(km, 0.1) < 12 ? 'llana' : 'montana', nombre: dp ? '' : val('nombre'), tiempo: dp ? '' : val('tiempo'), dorsal: dp ? '' : val('dorsal') };
  };

  /* Textos como los graba la app de taller: tal cual los escribe el cliente, letra de trazo único */
  const lineas = () => {
   const d = datos(), L = window.ATGrabado.lineas(d);
   return { l1: L[0] || T.tuCarrera, l2: L[1] || '— km', l3: d.nombre ? L[2] : [T.tuNombre, L[2]].filter(Boolean).join(' | '), frente: [d.nombre || T.tuNombre, d.tiempo].filter(Boolean).join(' · ') };
  };

  const pintarTextos = () => {
   const L = lineas();
   qa('[data-atc-cf]').forEach((e) => { e.textContent = L.frente; });
   qa('[data-atc-ci]').forEach((e) => { e.textContent = L.l1; });
   qa('[data-atc-cd]').forEach((e) => { e.textContent = L.l2; });
   const fr = sp.m && S.s ? window.ATGrabado.frente(cuad ? 'gestaC' : C.modelo, [L.l1, L.l2, L.l3], perfil() ? 6 : 0) : null;
   const tr = q('[data-atc-trazo]'), se = q('[data-atc-sello]');
   if (!fr) return;
   if (tr) { tr.setAttribute('d', fr.d); tr.setAttribute('stroke-width', Math.max(0.2, 0.9 / S.s).toFixed(2)); }
   const z = fr.sello;
   if (se) Object.assign(se.style, { left: z.x * S.s + 'px', top: z.y * S.s + 'px', width: z.size * S.s + 'px', height: z.size * S.s + 'px' });
  };

  /* Código para la app de taller: Sandro pega el pedido en Relieve 3D y la pieza se monta sola */
  const codigo = () => {
   const h = q('[data-atc-h="codigo"]');
   if (!h) return;
   const d = datos(), t = tipo(), c = q('[data-atc-color]:checked');
   const o = { v: 1, m: C.modelo, f: cuad ? 'cuadrado' : 'horizontal', b: perfil() ? 'perfilados' : 'rectos', c: d.carrera, n: d.nombre, t: d.tiempo, d: d.dorsal, dp: despues() ? 1 : 0,
    tr: t === EDIF ? 'ciudad' : /^Ciudad/.test(t) ? 'ciudad-sin' : 'montana', g: d.g, rc: color(), rn: c ? c.value : '', mc: mapa(),
    km: d.km || null, dm: d.dm, l: C.en ? 'en' : 'es', u: val('enlace'), nt: (q('textarea[name*="Notas"]')?.value || '').trim() };
   const poly = q('[data-atc-h="poly"]');
   if (S.pts && poly) o.rp = poly.value.slice(0, 16);
   if (S.v) { const i = window.ATMapa.info(S.v, A); o.e = { la: +i.centro[0].toFixed(6), lo: +i.centro[1].toFixed(6), w: +i.anchoKm.toFixed(4), r: Math.round(S.v.ang) }; }
   h.value = 'AT1' + JSON.stringify(o);
   h.disabled = false;
  };

  const encuadre = () => {
   const h = q('[data-atc-h="encuadre"]');
   if (!h) return;
   if (!S.v) { h.disabled = true; return; }
   const i = window.ATMapa.info(S.v, A);
   const ll = (p) => `${p[0].toFixed(5)}, ${p[1].toFixed(5)}`;
   const g = Math.round(i.giro);
   const giro = g === 0 ? 'norte arriba' : `${Math.abs(g)}° ${g > 0 ? 'antihorario' : 'horario'}`;
   h.value = `${cuad ? 'Cuadrado · ' : ''}Centro ${ll(i.centro)} · ${coma(i.anchoKm, 2)} × ${coma(i.altoKm, 2)} km · giro ${giro}${S.manual ? ' · ajustado por el cliente' : ''} · esquinas de la pieza: arriba izq. ${ll(i.esq[0])} | arriba der. ${ll(i.esq[1])} | abajo der. ${ll(i.esq[2])} | abajo izq. ${ll(i.esq[3])}`;
   h.disabled = false;
   codigo();
  };

  let raf = 0;
  const pintarMapa = () => {
   const cv = q('[data-atc-mapa]');
   const est = q('[data-atc-estado]');
   if (!cv || !window.ATMapa || !S.s) return;
   if (!S.pts || !S.v) {
    window.ATMapa.vacio(cv, T.sinRuta, mapa());
    if (est) est.textContent = T.notaVacia;
    return;
   }
   encuadre();
   cancelAnimationFrame(raf);
   raf = requestAnimationFrame(async () => {
    const r = await window.ATMapa.render(cv, S.pts, S.v, { color: color(), mapa: mapa(), lineMM: C.modelo === 'hito' ? 0.9 : 1.2, mapMM: MW });
    if (r && est) est.textContent = (r.ok ? '' : T.sinRelieve + ' ') + T.notaPrueba;
   });
  };

  const maquetar = (forzar) => {
   const esc = q('[data-atc-escena]');
   const pz = q('[data-atc-pieza]');
   const rel = q('[data-atc-relieve]');
   const cv = q('[data-atc-mapa]');
   if (!esc || !pz || !rel || !cv) return;
   const avail = esc.clientWidth || 320;
   const s = Math.min(avail / W, Math.min(440, (window.innerHeight || 800) * 0.55) / H);
   if (!forzar && Math.abs(s - S.s) < 0.002) return;
   S.s = s;
   pz.style.width = W * s + 'px';
   pz.style.height = H * s + 'px';
   pz.style.setProperty('--mm', s + 'px');
   pz.classList.toggle('atc-pieza--cuadrada', cuad);
   q('[data-atc-grab]')?.setAttribute('viewBox', `0 0 ${W} ${H}`);
   const mx = ((W - MW) / 2) * s;
   const my = ((H - MH) / 2) * s;
   Object.assign(rel.style, { left: mx + 'px', top: my + 'px', width: MW * s + 'px', height: MH * s + 'px' });
   const dpr = Math.min(2, window.devicePixelRatio || 1);
   cv.width = Math.round(MW * s * dpr);
   cv.height = Math.round(MH * s * dpr);
   pintarTextos();
   pintarMapa();
  };

  const mover = (du, dv) => {
   const a = (S.v.ang * Math.PI) / 180, c = Math.cos(a), s = Math.sin(a);
   S.v.cx += du * c - dv * s;
   S.v.cy += du * s + dv * c;
   S.manual = true;
   pintarMapa();
  };

  const actualizar = () => {
   const r = $r();
   if (!r) return;
   const c = ciudad();
   const bm = q('[data-atc-bloq="modelo"]');
   if (bm) bm.hidden = c !== 'bloqueo';
   const bl = q('[data-atc-bloq="largo"]');
   if (bl) bl.hidden = c !== 'largo';
   const km = q('[data-atc-km]');
   if (km && S.st) km.textContent = S.st.km.toFixed(1).replace('.', sd);
   const cf = q('[data-atc-conf]');
   if (cf) cf.hidden = !(tipo() === EDIF && C.modelo === 'leyenda' && !S.st);
   const hc = q('[data-atc-h="ciudad"]');
   if (hc) {
    hc.disabled = c !== 'ok';
    hc.value = S.st ? `${coma(S.st.km, 1)} km (GPX)` : '21,1 km o menos (confirmado)';
   }
   const enCiudad = /^Ciudad/.test(tipo());
   const negro = q('[data-atc-mapa-color][value="Negro"]');
   const blanco = q('[data-atc-mapa-color][value="Blanco"]');
   if (negro && blanco) {
    const antes = mapa();
    negro.disabled = enCiudad;
    if (enCiudad) blanco.checked = true;
    const nc = q('[data-atc-nota-ciudad]');
    if (nc) nc.hidden = !enCiudad;
    if (antes !== mapa()) pintarMapa();
   }
   const d = despues();
   const datos = q('[data-atc-datos]');
   if (datos) datos.hidden = d;
   const hd = q('[data-atc-h="despues"]');
   if (hd) hd.disabled = !d;
   const nom = q('[data-atc-in="nombre"]');
   if (nom) nom.required = !d;
   q('[data-atc-pieza]')?.classList.toggle('atc-pieza--perfil', perfil() && C.modelo !== 'hito');
   r.closest('.shopify-section')?.classList.toggle('at-bloqueo', !!motivo());
   codigo();
  };

  const props = () => {
   const poly = q('[data-atc-h="poly"]');
   const datos = q('[data-atc-h="datos"]');
   if (!poly || !datos) return;
   if (S.pts) {
    let tol = 3;
    let simp = window.ATMapa.simplify(S.pts, tol);
    while (simp.length > 1500) {
     tol *= 1.6;
     simp = window.ATMapa.simplify(S.pts, tol);
    }
    poly.value = window.ATMapa.encode(simp);
    datos.value = `${coma(S.st.km, 2)} km · D+ ${S.st.dmas != null ? Math.round(S.st.dmas) : '?'} m · ${S.pts.length} puntos`;
   }
   poly.disabled = !S.pts;
   datos.disabled = !S.pts;
  };

  const ponerGiro = () => {
   const g = q('[data-atc-giro]');
   if (g && S.v) g.value = String(Math.round(S.v.ang));
  };

  const onFile = async (inp) => {
   const f = inp.files && inp.files[0];
   const ok = q('[data-atc-ok]');
   const err = q('[data-atc-err="gpx"]');
   Object.assign(S, { pts: null, st: null, v: null, v0: null, gpxErr: false, manual: false });
   if (ok) ok.hidden = true;
   if (err) err.hidden = true;
   if (f) {
    try {
     if (f.size > 15e6) throw new Error('grande');
     const g = window.ATMapa.parseGPX(await f.text());
     S.pts = g.pts;
     S.st = window.ATMapa.stats(g.pts);
     S.v0 = window.ATMapa.mejorVista(g.pts, A);
     S.v = { ...S.v0 };
     if (ok) {
      ok.textContent = `✓ ${f.name} · ${kmTxt(S.st.km).toLowerCase()}${S.st.dmas != null ? ` · D+ ${miles(Math.round(S.st.dmas / 10) * 10)} m` : ''}`;
      ok.hidden = false;
     }
     const re = q('[data-atc-err="recorrido"]');
     if (re) re.hidden = true;
    } catch (e) {
     Object.assign(S, { gpxErr: true, pts: null, st: null, v: null });
     if (err) {
      err.textContent = e.message === 'grande' ? T.gpxGrande : T.gpxMal;
      err.hidden = false;
     }
    }
   }
   const ctrl = q('[data-atc-ctrl]');
   if (ctrl) ctrl.hidden = !S.v;
   ponerGiro();
   props();
   actualizar();
   pintarTextos();
   pintarMapa();
   if (S.pts && !S.visto) {
    S.visto = true;
    const pv = q('[data-atc-prev]');
    const rc = pv?.getBoundingClientRect();
    if (rc && (rc.bottom < 0 || rc.top > window.innerHeight)) pv.scrollIntoView({ behavior: 'smooth', block: 'center' });
   }
  };

  /* Elige en el selector de variante del tema (oculto) el valor que marca el cliente: bordes o formato */
  const elegirBorde = (v) => {
   const sec = $r()?.closest('.shopify-section') || document;
   const radio = [...sec.querySelectorAll('input[type="radio"]')].find((i) => !i.closest('[data-atc]') && i.value.trim().toLowerCase() === v.toLowerCase());
   if (radio) { if (!radio.checked) radio.click(); return; }
   for (const sel of sec.querySelectorAll('select')) {
    const o = [...sel.options].find((x) => x.value.trim().toLowerCase() === v.toLowerCase());
    if (o) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
   }
  };

  const cambiarFormato = () => {
   fijar();
   if (S.pts) {
    S.v0 = window.ATMapa.mejorVista(S.pts, A);
    S.v = { ...S.v0 };
    S.manual = false;
    ponerGiro();
   }
   maquetar(true);
  };

  const GRUPO = { carrera: 'carrera', recorrido: 'recorrido', tipo: 'tipo', nombre: 'datos' };
  const avisar = (m) => {
   let el = null;
   if (GRUPO[m]) {
    const e = q(`[data-atc-err="${m}"]`);
    if (e) e.hidden = false;
    el = q(`[data-atc-g="${GRUPO[m]}"]`);
   } else if (m === 'ciudad') el = q('[data-atc-bloq]:not([hidden])');
   else el = q('[data-atc-conf]');
   if (!el) return;
   el.scrollIntoView({ behavior: 'smooth', block: 'center' });
   el.classList.remove('at-flash');
   void el.offsetWidth;
   el.classList.add('at-flash');
  };

  const esCompra = (t) => {
   const b = t instanceof Element ? t.closest('button, input[type="submit"]') : null;
   if (!b || b.closest('[data-atc]') || b.type !== 'submit') return false;
   const f = b.form || b.closest('form');
   return !!f && f.getAttribute('id') === C.form;
  };
  const frenar = (e) => {
   const m = motivo();
   if (!m) return;
   e.preventDefault();
   e.stopImmediatePropagation();
   avisar(m);
  };
  window.addEventListener('click', (e) => { if (esCompra(e.target)) { codigo(); frenar(e); } }, true);
  window.addEventListener('submit', (e) => { if (e.target instanceof HTMLFormElement && e.target.getAttribute('id') === C.form) { codigo(); frenar(e); } }, true);

  const ocultarErr = (t) => {
   t.closest('[data-atc-g]')?.querySelectorAll('[data-atc-err]:not([data-atc-err="gpx"])').forEach((e) => { e.hidden = true; });
  };
  document.addEventListener('input', (e) => {
   const t = e.target;
   if (!(t instanceof Element) || !$r()?.contains(t)) return;
   if (t.matches('[data-atc-giro]') && S.v) {
    S.v.ang = Number(t.value) || 0;
    S.manual = true;
    pintarMapa();
    return;
   }
   ocultarErr(t);
   if (t.matches('[data-atc-in]')) pintarTextos();
   actualizar();
  });
  document.addEventListener('change', (e) => {
   const t = e.target;
   if (!(t instanceof Element) || !$r()?.contains(t)) return;
   ocultarErr(t);
   if (t.matches('[data-atc-gpx]')) return onFile(t);
   if (t.matches('[data-atc-formato]')) { cambiarFormato(); elegirBorde(t.value); [300, 1000].forEach((ms) => setTimeout(() => maquetar(true), ms)); }
   if (t.matches('[data-atc-borde]')) { elegirBorde(t.value); [300, 1000].forEach((ms) => setTimeout(() => maquetar(true), ms)); }
   if (t.matches('[data-atc-color], [data-atc-mapa-color]')) pintarMapa();
   pintarTextos();
   actualizar();
  });
  document.addEventListener('click', (e) => {
   const b = e.target instanceof Element ? e.target.closest('[data-atc-z], [data-atc-reset]') : null;
   if (!b || !$r()?.contains(b) || !S.v) return;
   e.preventDefault();
   if (b.hasAttribute('data-atc-reset')) {
    S.v = { ...S.v0 };
    S.manual = false;
    ponerGiro();
   } else {
    const f = Number(b.dataset.atcZ) > 0 ? 0.85 : 1 / 0.85;
    S.v.w = Math.min(S.v0.w * 4, Math.max(S.v0.w * 0.15, S.v.w * f));
    S.manual = true;
   }
   pintarMapa();
  });

  const cv = q('[data-atc-mapa]');
  let drag = null;
  if (cv) {
   cv.addEventListener('pointerdown', (e) => {
    if (!S.v) return;
    drag = { x: e.clientX, y: e.clientY };
    cv.setPointerCapture(e.pointerId);
   });
   cv.addEventListener('pointermove', (e) => {
    if (!drag || !S.v) return;
    const k = (MW * S.s) / S.v.w;
    const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    drag = { x: e.clientX, y: e.clientY };
    mover(-dx / k, -dy / k);
   });
   const fin = () => { drag = null; };
   cv.addEventListener('pointerup', fin);
   cv.addEventListener('pointercancel', fin);
  }

  document.addEventListener('variant:update', () => setTimeout(() => maquetar(true), 80));

  const esc = q('[data-atc-escena]');
  if (esc && window.ResizeObserver) new ResizeObserver(() => maquetar()).observe(esc);
  maquetar(true);
  actualizar();
  const g = q('[data-atc-gpx]');
  if (g && g.files && g.files.length) onFile(g);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pintarTextos);
 };

 const arrancar = () => document.querySelectorAll('[data-atc-cfg]').forEach(init);
 arrancar();
 document.addEventListener('shopify:section:load', arrancar);
})();
